import { createContext, useContext } from 'react';
import { type InboxContext as InboxContextType } from '@bridebook/web/components/inbox/context/types';

const initialValue: InboxContextType = {
  setConversationId: (): void => {
    throw new Error('setConversationId function must be overridden');
  },
};

const InboxContext = createContext<InboxContextType>(initialValue);

export const InboxContextProvider = InboxContext.Provider;

export const useInboxContext = (): InboxContextType => {
  const context = useContext(InboxContext);
  if (context === undefined) {
    throw new Error('InboxContextConsumer must be used within a InboxContextProvider');
  }

  return context;
};
